const ROLE_WORDS: [RegExp, string][] = [
  [/\b(wife|husband|spouse)\b/i, 'Spouse'],
  [/\bpartner\b/i, 'Partner'],
  [/\b(son|daughter|child)\b/i, 'Child'],
  [/\b(mother|father|parent)\b/i, 'Parent'],
  [/\b(brother|sister|sibling)\b/i, 'Sibling'],
];

/** The family role the document's wording points to, for the adviser to check. */
export function roleNameFromRelationship(relationship?: string | null): string | null {
  if (!relationship) return null;
  return ROLE_WORDS.find(([words]) => words.test(relationship))?.[1] ?? null;
}

export function splitName(name: string): { first: string; last: string } {
  const words = name.trim().split(/\s+/);
  return { first: words[0] ?? '', last: words.length > 1 ? words[words.length - 1] : '' };
}

export function formatBirthDate(dateOfBirth?: string | null): string | null {
  if (!dateOfBirth) return null;
  return new Date(dateOfBirth).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

export const initials = (name: string) =>
  name
    .split(' ')
    .filter(Boolean)
    .map(word => word[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
